import React from "react";
import { Navigate, useRoutes } from "react-router-dom";
import MainLayout from "../Layout";
import MainPage from "../Pages/app";
import UpgradeMembership from "../Pages/app/Upgrade";
import ApplicationStatus from "../Pages/ApplicationStatus";
import ApplicationCancelled from "../Pages/ApplicationCancelled";
import ExistingMembershipForm from "../Components/ExistingMemberShipForm";
import SuccessPage from "../Components/ExistingMemberShipForm/SuccessPage";
// import Logout from "../Pages/auth/Logout";
import OfficeUpdateForm from "../Pages/office-update/OfficeUpdateForm";
import UserForm from "../Pages/admin/UserForm";

export default function PrivateRoutes() {
  return useRoutes([
    {
      path: "app",
      element: <MainLayout />,
      children: [
        { path: "", element: <Navigate to={"/app/plan-status"} replace /> },
        { path: ":step/:user_id?", element: <MainPage /> },
        { path: "upgrade/:step/:user_id?", element: <UpgradeMembership /> },
        { path: "*", element: <Navigate to={"/app/plan-status"} replace /> },
      ],
    },
    {
      path: "application-cancelled/:user_id?",
      element: <ApplicationCancelled />,
    },
    {
      path: "application/:num/:user_id/:status",
      element: <ApplicationStatus />,
    },
    {
      path: "renew-checkout-revive/:app_id",
      element: <></>,
    },
    {
      path: "user/update-details/:user_id/:from?",
      element: <ExistingMembershipForm />,
    },
    {
      path: "user/update-details/:user_id/thanks/:recorded",
      element: <SuccessPage />,
    },
    {
      path: "admin-update",
      element: <MainLayout />,
      children: [{ path: "user/:step/:user_id?", element: <UserForm /> }],
    },
    // {
    //   path: "logout",
    //   element: <Logout />,
    // },
    {
      path: "office-update",
      element: <MainLayout />,
      // In user_id receiving app_id
      children: [
        { path: "user/:step/:user_id?", element: <OfficeUpdateForm /> },
      ],
    },
    {
      path: "admin-update",
      element: <MainLayout />,
      children: [{ path: "user/:step/:user_id?", element: <UserForm /> }],
    },
    { path: "*", element: <Navigate to={"app/plan-status"} replace /> },
  ]);
}
